// extracted by mini-css-extract-plugin
export default {"AuthenticationFooter":"AuthenticationFooter_AuthenticationFooter__5lsyG"};